import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadProvingsPersonsViewQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadProvingsPersonsViewQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_deleted' | 'id' | '_id' | 'type' | 'status' | 'title' | 'description' | 'dateTo' | 'dateFrom' | 'created' | 'department'>
    & { createdBy: (
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn' | 'companyName' | 'userType'>
    ), editor: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn' | 'companyName' | 'userType'>
    )>>, responsible: Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn' | 'companyName' | 'userType'>
    )>, resourceManager: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn' | 'companyName' | 'userType'>
    )>>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title' | 'countryCode'>
    )>, participants: Types.Maybe<Array<(
      { __typename?: 'Participant' }
      & Pick<Types.Participant, '_id' | 'orderId' | 'dateTo' | 'dateFrom' | 'percentage' | 'nordschleife' | 'nordschleifeBookingStatus'>
      & { person: Types.Maybe<(
        { __typename?: 'User' }
        & Pick<Types.User, 'department' | 'upn' | 'external' | 'roles' | 'companyName' | 'userType' | 'extension' | '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'employeeId'>
      ) | (
        { __typename?: 'Worker' }
        & Pick<Types.Worker, 'company' | 'department' | 'annotation' | 'qBasic' | 'qTurbo' | 'qSupersport' | 'qNordschleife' | 'qMuLow' | 'qOffroad' | '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email' | 'employeeId'>
      )>, unknownPerson: Types.Maybe<(
        { __typename?: 'UnknownPerson' }
        & Pick<Types.UnknownPerson, 'isUnknown' | 'personType' | 'department' | 'supplier' | 'employee' | 'firstName' | 'surName'>
      )>, flight: Types.Maybe<(
        { __typename?: 'Flight' }
        & Pick<Types.Flight, 'flightType' | 'bookingStatus'>
      )>, accomodation: Types.Maybe<(
        { __typename?: 'Accomodation' }
        & Pick<Types.Accomodation, 'accomodationType' | 'dateFrom' | 'dateTo' | 'bookingStatus'>
        & { accomodation: Types.Maybe<(
          { __typename?: 'Lodging' }
          & Pick<Types.Lodging, '_id' | 'title' | 'inactive'>
        )> }
      )>, trackHotels: Types.Maybe<(
        { __typename?: 'TrackHotels' }
        & { outward: Types.Maybe<Array<(
          { __typename?: 'TrackHotel' }
          & Pick<Types.TrackHotel, 'dateFrom' | 'dateTo' | 'bookingStatus'>
          & { hotel: Types.Maybe<(
            { __typename?: 'Lodging' }
            & Pick<Types.Lodging, '_id' | 'title' | 'inactive'>
          )> }
        )>>, return: Types.Maybe<Array<(
          { __typename?: 'TrackHotel' }
          & Pick<Types.TrackHotel, 'dateFrom' | 'dateTo' | 'bookingStatus'>
          & { hotel: Types.Maybe<(
            { __typename?: 'Lodging' }
            & Pick<Types.Lodging, '_id' | 'title' | 'inactive'>
          )> }
        )>> }
      )>, rentalCar: Types.Maybe<(
        { __typename?: 'RentalCar' }
        & Pick<Types.RentalCar, 'dateTo' | 'dateFrom' | 'carType' | 'bookingStatus'>
      )>, ferry: Types.Maybe<(
        { __typename?: 'Ferry' }
        & Pick<Types.Ferry, 'dateTo' | 'timeTo' | 'dateFrom' | 'timeFrom' | 'bookingStatus'>
        & { outward: Types.Maybe<(
          { __typename?: 'FerryConnection' }
          & Pick<Types.FerryConnection, '_id' | 'title' | 'type' | 'origin' | 'destination'>
        )>, return: Types.Maybe<(
          { __typename?: 'FerryConnection' }
          & Pick<Types.FerryConnection, '_id' | 'title' | 'type' | 'origin' | 'destination'>
        )> }
      )> }
    )>> }
  )>, principal: Types.Maybe<(
    { __typename?: 'User' }
    & Pick<Types.User, '_id' | 'type' | 'upn' | 'name' | 'email' | 'roles' | 'companyName' | 'userType' | 'employeeId'>
  )> }
);

export const ReadProvingsPersonsViewDocument = gql`
    query ReadProvingsPersonsView($search: String) {
  provings(filter: {OR: [{title: {REGEX: $search, OPTIONS: "i"}}, {id: {REGEX: $search, OPTIONS: "i"}}, {department: {REGEX: $search, OPTIONS: "i"}}], status: {NIN: [8, 9, 10]}}) {
    _deleted
    id
    _id
    type
    status
    title
    description
    dateTo
    dateFrom
    created
    department
    createdBy {
      _id
      lastName
      firstName
      name
      department
      email
      upn
      companyName
      userType
    }
    editor {
      _id
      lastName
      firstName
      name
      department
      email
      upn
      companyName
      userType
    }
    responsible {
      _id
      lastName
      firstName
      name
      department
      email
      upn
      companyName
      userType
    }
    resourceManager {
      _id
      lastName
      firstName
      name
      department
      email
      upn
      companyName
      userType
    }
    provingGround {
      _id
      title
      countryCode
    }
    participants {
      _id
      person {
        _id
        type
        name
        firstName
        lastName
        email
        employeeId
        ... on Worker {
          company
          department
          annotation
          qBasic
          qTurbo
          qSupersport
          qNordschleife
          qMuLow
          qOffroad
        }
        ... on User {
          department
          upn
          external
          roles
          companyName
          userType
          extension
        }
      }
      unknownPerson {
        isUnknown
        personType
        department
        supplier
        employee
        firstName
        surName
      }
      orderId
      dateTo
      dateFrom
      percentage
      flight {
        flightType
        bookingStatus
      }
      accomodation {
        accomodationType
        accomodation {
          _id
          title
          inactive
        }
        dateFrom
        dateTo
        bookingStatus
      }
      trackHotels {
        outward {
          dateFrom
          dateTo
          hotel {
            _id
            title
            inactive
          }
          bookingStatus
        }
        return {
          dateFrom
          dateTo
          hotel {
            _id
            title
            inactive
          }
          bookingStatus
        }
      }
      rentalCar {
        dateTo
        dateFrom
        carType
        bookingStatus
      }
      ferry {
        outward {
          _id
          title
          type
          origin
          destination
        }
        return {
          _id
          title
          type
          origin
          destination
        }
        dateTo
        timeTo
        dateFrom
        timeFrom
        bookingStatus
      }
      nordschleife
      nordschleifeBookingStatus
    }
  }
  principal {
    _id
    type
    upn
    name
    email
    roles
    companyName
    userType
    employeeId
  }
}
    `;

    export function useReadProvingsPersonsViewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadProvingsPersonsViewQuery, ReadProvingsPersonsViewQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadProvingsPersonsViewQuery, ReadProvingsPersonsViewQueryVariables>(ReadProvingsPersonsViewDocument, baseOptions);
    };
      export function useReadProvingsPersonsViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadProvingsPersonsViewQuery, ReadProvingsPersonsViewQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadProvingsPersonsViewQuery, ReadProvingsPersonsViewQueryVariables>(ReadProvingsPersonsViewDocument, baseOptions);
      };
      
export type ReadProvingsPersonsViewQueryHookResult = ReturnType<typeof useReadProvingsPersonsViewQuery>;
export type ReadProvingsPersonsViewQueryResult = ApolloReactCommon.QueryResult<ReadProvingsPersonsViewQuery, ReadProvingsPersonsViewQueryVariables>;